import Alfix from "./Alfix";

export default Alfix;
